import { D38_19 } from "./D38_19"

export const D38_18 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Sales Performance Per Area",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Territory Name',
                        "columnName": 'TerritoryName',
                        "width": '370px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '170px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "TerritoryName",
                "endpoint": "D38.18",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "DistrictManagerCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": D38_19
                }
            }
        }
    }
}